"use client";

import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
`;

const StyledContent = styled(TooltipPrimitive.Content)`
  z-index: 50;
  width: fit-content;
  max-width: 280px;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 1.4;
  background-color: #1f2937;
  color: var(--color-text-inverse);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  &[data-state="delayed-open"] {
    animation: ${fadeIn} 0.15s ease-out;
  }

  &[data-state="closed"] {
    animation: ${fadeOut} 0.1s ease-in;
  }
`;

const StyledArrow = styled(TooltipPrimitive.Arrow)`
  fill: #1f2937;
`;

function TooltipProvider({
  delayDuration = 200,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      delayDuration={delayDuration}
      {...props}
    />
  );
}

function Tooltip(props: React.ComponentProps<typeof TooltipPrimitive.Root>) {
  return (
    <TooltipProvider>
      <TooltipPrimitive.Root {...props} />
    </TooltipProvider>
  );
}

function TooltipTrigger(props: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger {...props} />;
}

function TooltipContent({
  sideOffset = 4,
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) {
  return (
    <TooltipPrimitive.Portal>
      <StyledContent sideOffset={sideOffset} {...props}>
        {children}
        <StyledArrow width={10} height={5} />
      </StyledContent>
    </TooltipPrimitive.Portal>
  );
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
